<div class="flex flex-col items-center justify-center">
  <div class="relative size-30">
    <svg
      class="-rotate-90"
      width="120"
      height="120">
      <circle
        class="stroke-neutral-500"
        stroke-width="10"
        fill="transparent"
        r="52"
        cx="60"
        cy="60" />
      <circle
        data-test="ring-circle"
        class="ring_circle"
        [style.stroke]="color()"
        [style.stroke-dashoffset]="strokeDashoffset"
        stroke-width="10"
        fill="transparent"
        r="52"
        cx="60"
        cy="60" />
    </svg>
    <div class="font-barlow absolute inset-0 flex flex-col items-center justify-center">
      <span
        data-test="percentage-text"
        class="preset-title-2 text-primary-900">
        {{ percentage() | number: '1.0-0' }}%
      </span>
    </div>
  </div>
</div>
